import styled from 'styled-components';

const Image = styled.img`
  object-fit: contain;
  border: 1px solid transparent;
  transform: scale(1);
  transition: all 100ms ease-in;
  height: 93px;
  width: 100%;
  &:hover {
    border: 1px solid #ef8a17;
    transform: scale(1.1);
  }
`;

export { Image };
